import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-27e415ef")

_pushScopeId("data-v-27e415ef")
const _hoisted_1 = { class: "dt-open-api-footer-box" }
const _hoisted_2 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Copyright © 沐坤科技有限公司 "),
  /*#__PURE__*/_createVNode("span", { style: {"margin-left":"32px","cursor":"pointer"} }, "皖ICP备18021982号-1")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2
  ]))
})